import { Link } from 'react-router-dom';
import { WellnessBannerProps } from '../../../interface/interface';
import { CTA_BUTTON_CLASS } from '../../../constant/constant';

const WellnessBanner = ({
  eyebrow,
  headingLines,
  description,
  ctaLabel,
  ctaHref,
  image,
}: Readonly<WellnessBannerProps>) => {
  const content = (
    <div className="flex flex-col gap-3 md:max-w-[46%] md:gap-4 xl:max-w-[42%]">
      <span className="text-xs font-semibold uppercase tracking-wide text-secondary-green-600">
        {eyebrow}
      </span>

      <h2 className="text-2xl font-bold leading-tight text-primary-blue-500 md:text-3xl xl:text-4xl">
        {headingLines[0]}
        <br />
        {headingLines[1]}
      </h2>

      <p className="max-w-[420px] text-sm leading-relaxed text-grey-700 md:max-w-[480px] md:text-base">
        {description}
      </p>

      <div className="mt-1 md:mt-2">
        <Link to={ctaHref} className={CTA_BUTTON_CLASS}>
          {ctaLabel}
        </Link>
      </div>
    </div>
  );

  return (
    <section className="relative overflow-hidden bg-white">
      <div
        className="relative hidden min-h-[400px] items-center bg-cover bg-[position:78%_35%] md:flex xl:min-h-[450px]"
        style={{ backgroundImage: `url(${image.src})` }}
      >
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-r from-white from-0% via-white/70 via-45% to-transparent to-80%"
        />
        <div className="container-standard relative z-10">{content}</div>
      </div>

      <div className="container-standard flex flex-col gap-5 py-6 md:hidden">
        {content}
        <div className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl">
          <img
            src={image.src}
            alt={image.alt}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-[75%_35%]"
          />
        </div>
      </div>
    </section>
  );
};

export default WellnessBanner;
